import { Box } from '@mui/material'
import { CardContainer, CardTitle, TrendWrapper } from '../common/styles'
import { HeaderWrapper } from './styles'
import { MetricCardProps } from './types'
import { ProgressRow } from '../ProgressRow'
import { calculatePercentage, getProgressColor, getTrendSymbol, getTrendColor } from '../common/utils'
import { formatToPercentage } from '../../../../../../utils/format'
import { useTheme } from '@mui/material'

export const MetricCard = ({
  title,
  format = 'currency',
  value = 0,
  expectedValue = 0,
  lastYearPercentage
}: MetricCardProps) => {
  const theme = useTheme()
  const progress = calculatePercentage(value, expectedValue)
  const progressColor = getProgressColor(progress)

  return (
    <CardContainer>
      <HeaderWrapper>
        <CardTitle>{title}</CardTitle>
        <Box sx={{ width: theme.spacing(1) }} />
        {typeof lastYearPercentage === 'number' && (
          <TrendWrapper color={getTrendColor(lastYearPercentage)}>
            {getTrendSymbol(lastYearPercentage)}
            {' '}
            {formatToPercentage(Math.abs(lastYearPercentage))}
          </TrendWrapper>
        )}
      </HeaderWrapper>

      <ProgressRow
        small
        leftValue={value}
        leftFormat={format}
        leftColor={progressColor}
        rightValue={expectedValue}
        rightFormat={format}
        progressValue={progress}
        progressColor={progressColor}
      />
    </CardContainer>
  )
}
